import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { UserActions } from "../redux/UserActions";
import { Link } from "react-router-dom";

function Login() {
  const dispatch = useDispatch();
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");

  function loginUser() {
    dispatch(
      UserActions.login({
        user: JSON.stringify({
          mail: mail,
          password: password,
        }),
      })
    );
  }
  return (
    <div className="flex w-full items-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex-1 max-w-4xl mx-auto overflow-hidden bg-white rounded-md shadow-xl dark:bg-gray-800">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <img
            aria-hidden="true"
            className="object-cover w-full h-48 md:h-auto md:w-1/2"
            src="https://www-assets.perkbox.com/media/10061/i960/35245c899f5887e83a33.jpg"
            alt="Office"
          />
          <main className="flex flex-col w-full px-6 sm:p-12 md:w-1/2">
            <h1 className="my-3 text-2xl w-full text-left font-bold text-gray-700 dark:text-gray-200">
              Login
            </h1>
            <label className="w-full text-left text-gray-700 dark:text-gray-200">
              Email
            </label>
            <input
              className="rounded-md border-gray-200"
              type="email"
              placeholder="john@doe.com"
              onChange={(e) => setMail(e.target.value)}
            />

            <label className="w-full text-left pt-4 text-gray-700 dark:text-gray-200">
              Password
            </label>
            <input
              className="rounded-md border-gray-200"
              type="password"
              placeholder="*******"
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              type="button"
              className="mx-auto py-3 px-6 my-4 rounded-md cursor-pointer bg-blue-600 font-medium text-white"
              block
              tag={Link}
              to="/app"
              value="Log In"
              onClick={() => loginUser()}
            />

            <hr className="my-8" />

            <p className="pt-4">
              <Link
                className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                to="/forgot-password"
              >
                Forgot your password?
              </Link>
            </p>
            {/* <p className="pb-4">
              <Link
                className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                to="/create_account"
              >
                Register organization
              </Link>
            </p> */}
          </main>
        </div>
      </div>
    </div>
  );
}

export default Login;
